import { styled as e, css as i } from "styled-components";
import { SmallStoreCard as a } from "../SmallStoreCard/index.js";
import { skeletonFadeAnimation as n } from "../../styles/animation.js";
import { H3Heavy as p, Caption as d } from "../../styles/typography/index.js";
import { TextSkeleton as t } from "../TextSkeleton/index.js";
import { Skeleton as l } from "../Skeleton/index.js";
import { Colors as s } from "../../styles/colors/index.js";
import { Theme as m } from "../../styles/themes/index.js";
import { MediaQuery as x } from "../../styles/variables.js";
const F = e.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`, y = e.h2`
  display: inline-block;
  color: rgb(${m.colors.Alpha});

  ${p}
`, $ = e.p`
  ${d}
  margin: 4px 0px 12px;
  color: rgb(${s.Gray});
`, r = i`
  margin: 4px;
`, w = e(a)`
  ${r}
  padding: 8px 16px;
`, T = e.div`
  ${({ animate: o }) => n({ animate: o, disableBackground: !0 })}
`, v = e(l)`
  height: 48px;
  border-radius: 12px;
  ${r}
`, M = e(t)`
  width: 100%;
  max-width: 308px;
  border-radius: 12px;
  height: 24px;
`, A = e(t)`
  width: 100%;
  max-width: 204px;
  border-radius: 12px;
  height: 18px;
`, D = e.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  margin-bottom: 16px;

  @media ${x.SCREEN_MD_UP} {
    margin-bottom: 12px;
  }
`;
export {
  A as FeatureStoreCardSkeletonSubtitlte,
  M as FeatureStoreCardSkeletonTitlte,
  v as FeaturedStoreCardSkeleton,
  D as FeaturedStoreCardSkeletonTitleContainer,
  w as FeaturedStoresCard,
  $ as FeaturedStoresDescription,
  F as FeaturedStoresLabelsList,
  y as FeaturedStoresTitle,
  T as SkeletonContainer
};
